<mat-accordion *ngIf="meta?.created_by">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <span class="inline-flex items-center gap-2">
                    <mat-icon class="text-secondary" style="font-size: 18px; height: 18px; width: 18px;">info</mat-icon>
                    <span>{{ title }}</span>
                </span>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="mb-4 text-sm text-gray-800">
                <div class="mb-2"><span class="font-semibold mr-1">Created by :</span><span>{{ meta?.created_by?.fullname }} ({{ meta?.created_by?.email }})</span></div>
                <div><span class="font-semibold mr-1">Created on :</span><span>{{ meta?.created_on | date:'short' }}</span></div>
            </div>
            <div class="mb-4 text-sm text-gray-800">
                <div class="mb-2"><span class="font-semibold mr-1">Updated by :</span><span>{{ meta?.updated_by?.fullname }} ({{ meta?.updated_by?.email }})</span></div>
                <div><span class="font-semibold mr-1">Updated on :</span><span>{{ meta?.updated_on | date:'short' }}</span></div>
            </div>
        </div>

        <ng-content></ng-content>
    </mat-expansion-panel>
</mat-accordion>